import Center from './Center';
export default Center;
//# sourceMappingURL=index.js.map